import { store } from '../store';

export const getAvailableChannels = () => {
  const userCanPlayChannel = store.getState()?.linealChannel?.data; //object with groupId that user can play
  const channelAvailableByRegion = store.getState().Player?.EpgChannels?.data; //array with channels available by region
  let AvailableChannelsToPlay = [];

  for (let channel of channelAvailableByRegion) {
    if (userCanPlayChannel?.[channel?.group_id]) {
      AvailableChannelsToPlay = [...AvailableChannelsToPlay, channel];
    }
  }
  return AvailableChannelsToPlay;
};
